module.exports = __webpack_public_path__ + "static/media/TranscoiniSafeADA.e3216e63.png";